import * as React from 'react';
import ChatMessageViewState from '../store/schema/ChatMessageViewState';

export interface ChatMessageProps {
    chatMessage: ChatMessageViewState;
}

export default function ChatMessage(props: ChatMessageProps) {
    const { chatMessage } = props;
    return (
        <div>
            <div>{chatMessage.fromDisplayName}</div>
            <div>
                <pre>{chatMessage.message}</pre>
            </div>
        </div>
    );
}
